import request from '@/axios'

export const getDynamicUrlApi = () => {
  return request.get({
    url: '/api/router/dynamic-url',
    params: { hostname: window.location.hostname }
  })
}

export const getCostBusinessDynamicUrlApi = () => {
  return request.get({
    url: '/api/router/costBusiness-dynamic-url',
    params: { hostname: window.location.hostname }
  })
}
